<template>
  <nav v-if="state.pagination.pages.length > 1">
    <ul class="pagination justify-content-center">
      <li class="page-item">
        <a class="page-link" href="javascript:void(0);" tabindex="-1"
            @click="goPreviousPage()">Anterior</a>
      </li>
      <li class="page-item" :class="{ active: page == state.pagination.currentPage }"
          v-for="page in state.pagination.pages" :key="page"
          @click="setPage(page);">
        <a class="page-link" href="javascript:void(0);">
          {{ page }}
          <span v-if="page == state.pagination.currentPage" class="sr-only">(current)</span>
        </a>
      </li>
      <li class="page-item">
        <a class="page-link" href="javascript:void(0);" @click="goNextPage()">Próxima</a>
      </li>
    </ul>
  </nav>
</template>
<script>
import {
  reactive, toRefs, watch, onMounted,
} from 'vue';
import { useStore } from 'vuex';

export default {
  props: {
    total: Number,
  },
  setup(props) {
    const store = useStore();

    const { total } = toRefs(props);

    const pagination = {
      pages: [],
      currentPage: 1,
      lastPage: 0,
    }

    const state = reactive({
      pagination,
      total,
    });

    const startPaginate = () => {
      state.pagination.lastPage = Math.ceil(state.total / 12);
      state.pagination.pages = new Array(state.pagination.lastPage).fill(null).map((_, i) => i + 1);
    }

    watch(total, async () => {
      startPaginate();
      state.pagination.currentPage = 1;
    });

    onMounted(() => {
      startPaginate();
    });

    const setPage = (page) => {
      state.pagination.currentPage = page;

      const filter = store.state.jobs.jobsFilters;
      store.dispatch('getJobs', { jobsFilters: { page, ...filter } });
    }

    const goPreviousPage = () => {
      const page = state.pagination.currentPage > 1 ? state.pagination.currentPage - 1 : 1;
      setPage(page);
    }

    const goNextPage = () => {
      const page = state.pagination.currentPage < state.pagination.lastPage
        ? state.pagination.currentPage + 1 : state.pagination.lastPage;
      setPage(page);
    }

    return {
      state,
      setPage,
      goPreviousPage,
      goNextPage,
    };
  },
}
</script>

<style lang="scss" scoped>
.pagination {
  gap: 6px;
}

.pagination .page-link {
  font-family: var(--font-brand);
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
  background-color: var(--navy-card);
  border: 1px solid var(--navy-border);
  border-radius: var(--r-sm);
  transition: background-color 0.15s var(--ease), color 0.15s var(--ease), border-color 0.15s var(--ease);
}

.pagination .page-link:hover {
  color: var(--cyan);
  background-color: var(--cyan-glow);
  border-color: var(--cyan);
}

.pagination .page-link:focus {
  box-shadow: 0 0 0 2px var(--cyan-glow);
}

.pagination .page-item.active .page-link {
  color: var(--navy-deep);
  background-color: var(--cyan);
  border-color: var(--cyan);
}
</style>
